"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarFooterButton;

var _react = _interopRequireDefault(require("react"));

var _UIButton = _interopRequireDefault(require("../../button/UIButton"));

function CalendarFooterButton(props) {
  return _react.default.createElement(_UIButton.default, Object.assign({
    use: "tertiary-light",
    size: "xs",
    responsive: false
  }, props));
}

module.exports = exports.default;